import React, { Fragment } from 'react';
import { Field } from 'formik';
import { FovToggle, VerticalSpacer } from 'components';
import { ToggleContainer } from './RPCFormStyles';

const AIFields = ({ form, isImageProvided, useAI, setUseAI, multipleFiles }) => {
  if (!isImageProvided) {
    return null;
  }

  return (
    <Fragment>
      <ToggleContainer>
        {multipleFiles ? 'Multi-image to 3D' : 'Image to 3D'}
        <VerticalSpacer size={10} />

        <Field type='checkbox' name='ai'>
          {data => (
            <FovToggle
              checked={useAI}
              callback={newVal => {
                form.setFieldValue(data.field.name, newVal);
                setUseAI(newVal);
              }}
            />
          )}
        </Field>
      </ToggleContainer>
      <VerticalSpacer size={10} />
    </Fragment>
  );
};

export default AIFields;

